var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{attrs:{"show":_vm.loading,"rounded":"sm"}},[_c('b-card',{staticClass:"plan-thumbnail",attrs:{"title":"","aria-hidden":_vm.loading ? 'true' : null}},[_c('img',{staticClass:"img-thumbnail",attrs:{"src":_vm.base64}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }